var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "tc-lmc-field-search field has-addons is-marginless",
      class: { "is-expanded": _vm.isExpanded },
    },
    [
      _c("div", { staticClass: "control" }, [
        _vm.closeButton
          ? _c(
              "button",
              {
                staticClass: "button close-button",
                class: [_vm.sizingClassNames],
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              },
              [_c("bulma-icon", { attrs: { name: "fas fa-arrow-left" } })],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c(
          "button",
          {
            staticClass: "button search-button",
            class: [_vm.sizingClassNames, { "is-loading": _vm.isLoading }],
            attrs: { type: "button", disabled: _vm.disabled || _vm.isLoading },
            on: { click: _vm.search },
          },
          [
            _c("bulma-icon", {
              attrs: {
                name: _vm.isSoftLoading
                  ? "fas fa-spinner fa-spin"
                  : "fas fa-search fa-no-spin",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "control is-expanded" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.modifiedValue,
              expression: "modifiedValue",
            },
          ],
          ref: "searchInput",
          staticClass: "input search-input",
          class: [_vm.sizingClassNames],
          attrs: {
            type: "text",
            required: _vm.required,
            readonly: _vm.readonly,
            placeholder: _vm.$gettext("Search..."),
          },
          domProps: { value: _vm.modifiedValue },
          on: {
            focus: function ($event) {
              return _vm.routeEvent("focus", $event)
            },
            mousedown: _vm.mousedown,
            keydown: function ($event) {
              return _vm.routeEvent("keydown", $event)
            },
            click: function ($event) {
              return _vm.routeEvent("click", $event)
            },
            keyup: _vm.keyup,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.modifiedValue = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "icon clear-icon",
            attrs: { title: _vm.$gettext("Clear value") },
            on: { click: _vm.clear },
          },
          [
            _c("icon", {
              attrs: { name: _vm.isMobile ? "fas fa-times" : "fas fa-times" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }